import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Avatar from "/src/assets/images/male-avatar.png";

function TableRecentsStatistics(dataRender: any) {
  const solicitanteBodyTemplate = (rowData: any) => {
    return (
      <div className="flex align-items-center gap-2">
        <img
          width="20px"
          height="20px"
          alt="solicitante"
          src={Avatar}
          style={{ width: "24px", paddingRight: "5px" }}
        />
        <span className="font-bold">
          {rowData.nombres} {rowData.user_apellido_paterno}
        </span>
      </div>
    );
  };

  const numberColorBodyTemplate = (rowData: any) => {
    const numberColorStyle = {
      padding: "5px",
      fontWeight: "bold",
      fontSize: "10px",
      background:
        rowData.total_solicitudes === 0
          ? "yellow"
          : rowData.total_solicitudes > 10
            ? "red"
            : "teal",
      width: "40px",
      borderRadius: "10px",
      textAlign: "center" as const,
      color: "white",
    };

    return <div style={numberColorStyle}>{rowData.total_solicitudes}</div>;
  };

  const hoursBodyTemplate = (rowData: any) => {
    const hoursStyle = {
      padding: "5px",
      fontWeight: "bold",
      fontSize: "10px",
      background:
        rowData.minutos_desde === 0
          ? "grey"
          : rowData.minutos_desde > 24
            ? "red"
            : "#acac00ff",
      borderRadius: "15px",
      textAlign: "center" as const,
      color: "white",
    };

    const hours = rowData.minutos_desde;
    const minutes = rowData.minutos_desde % 60;
    return (
      <div style={hoursStyle}>
        {hours} Horas y {minutes} Minutos
      </div>
    );
  };

  const renderByConditionalSwitch = (dataRender: any) => {
    const documentStyle = getComputedStyle(document.documentElement);

    switch (dataRender.operationType) {
      case "recent-solicitudes":
        return (
          <DataTable
            value={dataRender.dataRender}
            rowGroupMode="rowspan"
            groupRowsBy="minutos_desde"
            sortMode="single"
            sortOrder={1}
            sortField="minutos_desde"
            tableStyle={{ width: "100%" }}
          >
            <Column
              field="soc_id"
              header="N° "
              headerStyle={{ width: "5rem", color: "white" }}
              style={{
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>
            <Column
              field="subdoc_nombre"
              header="Tipo"
              headerStyle={{ color: "white" }}
              style={{
                width: "5rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>
            <Column
              field="user.nombres, user.apellido_paterno"
              header="Solicitante"
              headerStyle={{ color: "white" }}
              body={solicitanteBodyTemplate}
              style={{
                width: "10rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>
            <Column
              field="sdetcc_nombre"
              header="Centro Solicitante"
              headerStyle={{ color: "white" }}
              style={{
                width: "10rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>
            <Column
              field="soc_precio_total_ref"
              header="Precio Total"
              headerStyle={{ color: "white" }}
              style={{
                width: "10rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>

            <Column
              field="tipmon_codigo"
              header=""
              headerStyle={{ color: "white" }}
              style={{
                width: "1rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>

            <Column
              field="minutos_desde"
              header="Horas desde creación"
              headerStyle={{ color: "white" }}
              style={{
                width: "5rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
              body={hoursBodyTemplate}
            ></Column>
          </DataTable>
        );

      case "statistics-centros":
        return (
          <DataTable
            value={dataRender.dataRender}
            rowGroupMode="rowspan"
            groupRowsBy="total_solicitudes"
            sortMode="single"
            sortField="total_solicitudes"
            sortOrder={-1}
            tableStyle={{ minWidth: "26rem" }}
          >
            <Column
              field="cc_nombre"
              header="Centro Costo"
              headerStyle={{ width: "8rem", color: "white" }}
              style={{
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>
            <Column
              field="total_precio"
              header="Total Costos"
              headerStyle={{ color: "white" }}
              style={{
                width: "8rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>

            <Column
              field="tipmon_codigo"
              header="Moneda"
              headerStyle={{ color: "white" }}
              style={{
                width: "4rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
            ></Column>

            <Column
              field="total_solicitudes"
              header="Cantidad Solicitudes"
              headerStyle={{ color: "white" }}
              style={{
                width: "6rem",
                backgroundColor: documentStyle.getPropertyValue(
                  "--primary-app-dark-color",
                ),
                color: "white",
              }}
              body={numberColorBodyTemplate}
            ></Column>
          </DataTable>
        );
      default:
        return null;
    }
  };

  const renderData = () => {
    return <>{renderByConditionalSwitch(dataRender)}</>;
  };
  return <div className="card">{renderData()}</div>;
}

export default TableRecentsStatistics;
